/* eslint-disable no-await-in-loop */
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import * as moment from 'moment';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import UserSelector from 'components/Base/UserSelector';
import { updateCargoOrderUser, updateCargoOrder, addCargoOrder, removeLastCargoOrder } from 'actions/cargoes/orders';
import OrderTable from './Sidebar/OrderTable';
import AnnotationsEditor from './Content/AnnotationsEditor';
import AnnotationsList from './Content/AnnotationsList';
import HtmlContent from '../HtmlContent';
import TextEditor from './Content/TextEditor';

import ErrorBoundary from './ErrorBoundary';

import styles from 'styles';

import { portsTree } from 'helpers/cargoUtils';

import { execute } from 'store/configureStore';
import { getLetter } from 'sagas/letters';
import * as sagaAnnotations from 'sagas/annotations';
import * as sagaLetters from 'sagas/lettersNew';
import { saveRequestsDataCreated } from 'sagas/orders';

import { getCargoTypes } from 'actions/cargoes/types';
import { getCargoesByTypeName } from 'actions/cargoes/names';
import { getTermEntities } from 'actions/termEntities';
import { postRequestCargo } from 'actions/cargoes/requests';
import { getContracts } from 'actions/contracts';
import { getCargoAssigners } from 'actions/cargoes/assigners';
import { removeLetter } from 'actions/letters';
import { postAnnotations, removeAnnotations } from 'actions/annotations';
import { removeGazetters, postGazetters } from 'actions/gazetters';
import { addNotification } from 'actions/notifications/notifications';
import Attachments from 'components/Letters/Single/Attachments';
// import Trainings from 'components/Letters/Single/Gazetter/Trainings';
import { Checkbox } from 'material-ui';
import FailedToSent from '../../common/FailedToSent';
import api from 'services';
import helpers from '../../../../helpers';
import { fixVesselRequirementsData } from './Sidebar/Order/VesselRequirements';
import ToSpamButton from '../../common/ToSpamButton';

class LetterCargo extends React.Component {
    constructor(props) {
        super(props);

        if (localStorage.getItem(`settings-order-cargo${props.objUser.user._id}`)) {
            this.initialState = JSON.parse(localStorage.getItem(`settings-order-cargo${props.objUser.user._id}`));
        } else {
            this.initialState = { annotationsServer: 'mailparse.net', clarifiedServer: 'standart' };
            localStorage.setItem(`settings-order-cargo${props.objUser.user._id}`, JSON.stringify(this.initialState));
        }

        this.state = {
            ...this.initialState,
            textLetter: '',
            typeAnnotations: 'annotate',
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: false,
            clientCargo: undefined,
            openedAttachmentsDialog: false,

            selectedServer: 'mailparse.net',
            isSimpleForm: false,
            sendStatusPending: false,
            failedToSentOpen: false,
            isFormChanged: false,
            cargoOrdersDuplicates: [],
        };

        this.addOrderTable = this.addOrderTable.bind(this);
        this.sendRequestCargo = this.sendRequestCargo.bind(this);
        this.removeOrderTable = this.removeOrderTable.bind(this);
        this.clearOrderTable = this.clearOrderTable.bind(this);
        this.handleFillRequest = this.handleFillRequest.bind(this);
        this.changeAnnotationsServer = this.changeAnnotationsServer.bind(this);
        this.changeClarifiedServer = this.changeClarifiedServer.bind(this);
        this.getLetterData = this.getLetterData.bind(this);

        this.updatePostGazetters = this.updatePostGazetters.bind(this);

        this.handleClientChange = this.handleClientChange.bind(this);

        this.saveRequestsDataCreated = this.saveRequestsDataCreated.bind(this);
        this.sendRequestCargoFromSent = this.sendRequestCargoFromSent.bind(this);
    }

    async getLetterData(textEdit) {
        try {
            const { data: letter } = await execute(getLetter, this.props.routeParams.id, 'cargo');

            letter.gazettersArr = [];
            letter.type = 'cargo';
            letter.fromCargoOrders = true;

            if (textEdit) {
                letter.text = textEdit;
            }

            const annotationsResponse = await execute(
                sagaAnnotations.postAnnotations, 
                letter.text, 
                letter.type, 
                this.state.annotationsServer, 
                { 
                    emailId: letter._id, 
                    isSimpleForm: this.state.isSimpleForm,
                    subject: letter.subject,
                    date: moment(letter.date).format('DD-MM-YYYY'),
                },
            );

            if (annotationsResponse) {
                letter.gazettersArr = annotationsResponse.data.annotations;
                if (annotationsResponse.data.newclarified) {
                    letter.newclarified = annotationsResponse.data.newclarified;
                }
            }

            await execute(sagaLetters.updateLetter, _.omit(letter, 'gazettersArr'), 'cargo', this.state.clarifiedServer);
        } catch (error) {
            console.error(error);
        }
    }

    changeAnnotationsServer(e, i, value) {
        this.initialState = {
            annotationsServer: value,
            clarifiedServer: this.state.clarifiedServer,
        };

        localStorage.setItem(`settings-order-cargo${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(this.state.textLetter); });
    }

    changeClarifiedServer(e, i, value) {
        this.initialState = {
            annotationsServer: this.state.annotationsServer,
            clarifiedServer: value,
        };

        localStorage.setItem(`settings-order-cargo${this.props.objUser.user._id}`, JSON.stringify(this.initialState));

        this.setState(this.initialState, () => { this.getLetterData(this.state.textLetter); });
    }

    async componentDidMount() {
        const { state } = this.props.location;

        await this.props.getCargoTypes();
        await this.props.getCargoAssigners();
        await this.props.getTermEntities();
        await this.props.getContracts();

        await this.props.getCargoesByTypeName({ name: 'Container' });
        
        if (state) {
            this.getLetterData(state.modifiedTextLetter);
        } else {
            this.getLetterData();
        }
    }

    removeOrderTable() {
        this.props.removeLastCargoOrder();
    }

    clearOrderTable() {
        this.props.removeLastCargoOrder();
        this.props.addCargoOrder();
    }

    addOrderTable() {
        this.props.addCargoOrder();
    }

    async saveRequestsDataCreated(order) {
        try {
            await execute(saveRequestsDataCreated, 'cargo', { ...order, mailId: this.props.letter._id });
        } catch (error) {
            console.error(error);
        }
    }

    createCargoRequest(cargoOrder, keyCargoOrder, cargoRequests) {
        const cargoRequest = {
            ...cargoOrder,
            cargo: cargoOrder.cargo,
            keyCargoOrder,
        };

        if (this.state.packingListSelection) {
            cargoRequest.cargo[0].packingList = this.state.packingListSelection.items;
        }

        for (const type in cargoRequest.ldRates) {
            for (const key in cargoRequest.ldRates[type].cqd) {
                if (key !== 'cqd') {
                    cargoRequest.ldRates[type][key] = undefined;
                }
            }
        }

        this.saveRequestsDataCreated(cargoRequest);

        this.multiplyCargoRequests(cargoRequest, cargoRequests);

        cargoRequests.forEach((cargoRequest) => {
            cargoRequest.cargo.forEach((cargo) => {
                if (Array.isArray(cargo.packing.pack.unitsVolume)) {
                    cargo.packing.pack.unitsVolume = cargo.packing.pack.unitsVolume[0];
                }
    
                if (Array.isArray(cargo.packing.pack.unitsWeight)) {
                    cargo.packing.pack.unitsWeight = cargo.packing.pack.unitsWeight[0];
                }

                if (cargo.details === 2) {
                    cargo.clauses = _.filter(cargo.clauses, c => c.name !== 'Cradles to be for');
                } else if (cargo.details === 1) {
                    cargo.clauses = _.filter(
                        cargo.clauses, 
                        c => ['Shipment', 'Cradles to be for'].includes(c.name),
                    );
                } else {
                    cargo.clauses = [];
                }
            });

            cargoRequest.user = this.props.user.email;
        });

        return cargoRequests;
    }

    multiplyCargoRequests(cargoRequest, cargoRequests) {
        cargoRequests.push(cargoRequest);
        cargoRequest.cargo.forEach((cargo, index) => {
            const copy = JSON.parse(JSON.stringify(cargoRequest));
            let changed = false;
            const { unitsWeight, unitsVolume } = cargo.packing.pack;
            const { unitsWeight: copyUnitsWeight, unitsVolume: copyUnitsVolume } = copy.cargo[index].packing.pack;

            if (unitsWeight[1].value) {
                copyUnitsWeight[0] = copyUnitsWeight[1];
                changed = true;
            }

            if (unitsVolume[1].value) {
                copyUnitsVolume[0] = copyUnitsVolume[1];
                changed = true;
            }

            if (changed) {
                cargoRequests.push(copy);
            }
        }); 

        if (cargoRequest.cargo.length > 1) {
            const copy = JSON.parse(JSON.stringify(cargoRequest));
            let changed = false;
            copy.cargo.forEach((item) => {
                const { unitsWeight, unitsVolume } = item.packing.pack;

                if (unitsWeight[1].value) {
                    unitsWeight[0] = unitsWeight[1];
                    changed = true;
                }
    
                if (unitsVolume[1].value) {
                    unitsVolume[0] = unitsVolume[1];
                    changed = true;
                }
            });
            if (changed) {
                cargoRequests.push(copy);
            }
        }
    }

    createTerms(cargoOrders) {
        cargoOrders.forEach((cargoOrder) => {
            const user = _.cloneDeep(cargoOrder.terms.user);

            user.forEach((term) => {
                if (term.type) {
                    term.value = `${term.type} ${term.value}`;
                }
            });

            cargoOrder.terms.user = user;
        });
    }

    // flushes form changes that were not applied, such as setting selected "registered class" to the state despite user didn't click on the + button.
    saveHandlers = []

    sendRequestCargo() {
        const cargoOrders = _.cloneDeep(this.props.cargoOrders);

        cargoOrders.forEach((cargoOrder, i) => {
            if (!cargoOrder.vesselRequirements) {
                cargoOrder.vesselRequirements = {};
            }
            this.saveHandlers[i](cargoOrder);
        });

        let hasErrors = false;

        cargoOrders.forEach((cargoOrder, cIndex) => {
            // like that because user error is seperate from main cargo object
            cargoOrder.validateErrors = _.omitBy(cargoOrder.validateErrors, (i) => {
                i.field === 'user';
            });

            if (cargoOrder.validateErrors.length) {
                cargoOrder.validateErrors.forEach((error) => {
                    this.props.addNotification({
                        title: 'Error',
                        message: `Error in request #${cIndex + 1}. Field ${error.field} --- ${error.message || error.messages[0]}`,
                        level: 'error',
                        _id: Math.random(),
                        autoDismiss: 100,
                    });
                });

                hasErrors = true;
            }
        });

        if (hasErrors) {
            return;
        }

        this.setState({ sendStatusPending: true });

        if (!cargoOrders.length) {
            return;
        }

        this.setState({
            isFormChanged: false,
            cargoOrdersDuplicates: _.cloneDeep(this.props.cargoOrders),
        });

        const cargoRequests = [];

        this.createTerms(cargoOrders);

        cargoOrders.forEach((cargoOrder, keyCargoOrder) => {
            this.createCargoRequest(cargoOrder, keyCargoOrder, cargoRequests);
        });

        for (let cargoRequestIndex = 0; cargoRequestIndex < cargoRequests.length; cargoRequestIndex++) {
            const cargoRequest = cargoRequests[cargoRequestIndex];

            setTimeout(() => {
                this._prepareAndOrSendSingleRequest(cargoRequest, cargoRequestIndex);
                this.setState({ sendStatusPending: false });
            }, 1000);
        }
    }

    /**
     * @param {*} cargoRequest
     * @param {*} cargoRequestIndex
     * @param {boolean} [shouldReturnPrepared]
     * @param {import('../../../Letters/common/FailedToSent').FailedTwin} [opts]
     */
    _prepareAndOrSendSingleRequest(cargoRequest, cargoRequestIndex, shouldReturnPrepared = false, opts) {
        cargoRequest.loading = [];
        cargoRequest.unloading = [];

        portsTree(cargoRequest.loadingPortsMap, cargoRequest.loading);
        portsTree(cargoRequest.unloadingPortsMap, cargoRequest.unloading);

        if (
            cargoRequest.loading[0] &&
            cargoRequest.loading[0].oneOf[0]
        ) {
            cargoRequest.loadingPort = cargoRequest.loading[0].oneOf[0].port;
        }

        if (
            cargoRequest.unloading[0] &&
            cargoRequest.unloading[0].oneOf[0]
        ) {
            cargoRequest.unloadingPort = cargoRequest.unloading[0].oneOf[0].port;
        }

        if (this.state.clientCargo) {
            cargoRequest.realUserEmail = cargoRequest.user;
            cargoRequest.user = this.state.clientCargo;
            cargoRequest.requestKind = 'broker';
        } else {
            cargoRequest.requestKind = 'public';
        }

        let error = false;

        if (!cargoRequest.cargoType && cargoRequest.cargo[0]) {
            error = true;

            this.props.addNotification({
                title: 'Error',
                message: `Error in request #${cargoRequestIndex + 1}: main cargo type or cargo in request is not set`,
                level: 'error',
                _id: Math.random(),
                autoDismiss: 50,
            });
        }

        cargoRequest.cargo.forEach((cargo, index) => {
            if (
                cargo.packing.category !== 'container' &&
                !parseInt(cargo.packing.pack.unitsWeight.value, 10) && !parseInt(cargo.packing.pack.unitsVolume.value, 10)
            ) {
                error = true;
                this.props.addNotification({
                    title: 'Error',
                    message: `Error in request #${cargoRequestIndex + 1}, cargo #${index + 1}: weight OR volume must be specified`,
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 50,
                });
            }

            if (
                cargo.packing.category === 'container' &&
                (!cargo.containerDetails.kind || !cargo.packing.pack.bundlesQuantity)  
            ) {
                error = true;
                this.props.addNotification({
                    title: 'Error',
                    message: `Error in request #${cargoRequestIndex + 1}, cargo #${index + 1}: container kind and quantity are required.`,
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 50,
                });
            }

            if (!cargo.dangerous.unNumber) {
                cargo.dangerous.unNumber = undefined;
            }

            if (!cargo.dangerous.class[0]) {
                cargo.dangerous.class = [];
            }

            const { sf } = cargo.packing.pack;
            if (sf) {
                if (!parseInt(cargo.packing.pack.unitsVolume.value, 10)) {
                    cargo.packing.pack.unitsVolume.valueCalculated =
                        Math.ceil(cargo.packing.pack.unitsWeight.value * parseFloat(sf));
                    cargo.packing.pack.unitsVolume.value = 0;
                    cargo.packing.pack.unitsVolume.isCalc = true;
                } else {
                    cargo.packing.pack.unitsVolume.valueCalculated = parseInt(cargo.packing.pack.unitsVolume.value, 10);
                    cargo.packing.pack.unitsVolume.isCalc = false;
                }

                if (!parseInt(cargo.packing.pack.unitsWeight.value, 10)) {
                    cargo.packing.pack.unitsWeight.valueCalculated =
                        Math.ceil(cargo.packing.pack.unitsVolume.value / parseFloat(sf));
                    cargo.packing.pack.unitsWeight.value = 0;
                    cargo.packing.pack.unitsWeight.isCalc = true;
                } else {
                    cargo.packing.pack.unitsWeight.valueCalculated = parseInt(cargo.packing.pack.unitsWeight.value, 10);
                    cargo.packing.pack.unitsWeight.isCalc = false;
                }
            }

            if (!cargo.packing.pack.unitsWeight.value && !cargo.packing.pack.unitsWeight.valueCalculated) {
                cargo.packing.pack.unitsWeight = undefined;
            }

            if (!cargo.packing.pack.unitsVolume.value && !cargo.packing.pack.unitsVolume.valueCalculated) {
                cargo.packing.pack.unitsVolume = undefined;
            }

            if (!cargo.packing.pack.unitsQuantity) {
                delete cargo.packing.pack.unitsQuantity;
            }

            if (!cargo.hsCodeId._id) {
                cargo.hsCodeId = undefined;
            } else {
                cargo.hsCodeId = cargo.hsCodeId._id;
            }

            if (!cargo.packing.pack.bundlesQuantity) {
                cargo.packing.pack.bundlesQuantity = undefined;
            }

            if (cargo.typeOfTransportation === 'container') {
                if (cargo.packing.pack.unitWeight && !cargo.packing.pack.bundleWeight) {
                    cargo.packing.pack.bundleWeight = cargo.packing.pack.unitWeight;
                }
            }

            [
                'containerDetails',
            ].forEach((field) => {
                if (!Object.values(_.omit(cargo[field], ['owner'])).filter(i => i).length) {
                    cargo[field] = undefined;
                }
            });

            [
                'bundleBeam', 'bundleHeight', 'unitLength', 'netWeight', 'unitWeight',
                'maxUnitLength', 'maxUnitWidth', 'unitBeam', 'unitDiam', 'unitHeight',
                'unitVolume', 'bundleLength', 'unitsVolume', 'unitsWeight', 'bundleWeight',
            ].forEach((field) => {
                if (
                    !Object.values(_.omit(cargo.packing.pack[field], ['unit'])).filter(i => i).length
                ) {
                    cargo.packing.pack[field] = undefined;
                }
            });

            if (
                cargo.packing.pack.densities.length === 1 &&
                !Object.values(cargo.packing.pack.densities[0]).filter(i => i).length
            ) {
                cargo.packing.pack.densities = undefined;
            }

            if (
                cargo.packing.category === 'unpacked' && 
                cargo.details === 10 &&
                cargo.packing.pack.unitBeam && cargo.packing.pack.unitBeam.value
            ) {
                cargo.packing.pack.maxUnitWidth = cargo.packing.pack.unitBeam;
            }

            cargo.packingList.forEach((item, Iindex) => {
                if (!item.name && (item.weight || item.volume || item.quantity || (item.width && item.height && item.length))) {
                    error = true;

                    this.props.addNotification({
                        title: 'Error',
                        message: `Error in request #${cargoRequestIndex + 1}, packing list item #${Iindex + 1}: name not specified`,
                        level: 'error',
                        _id: Math.random(),
                        autoDismiss: 50,
                    });
                }
            });

            cargo.packingList = cargo.packingList
                .filter(item => item.name && (item.weight || item.volume || item.quantity || (item.width && item.height && item.length)));
        
            if (cargo.containerDetails && cargo.containerDetails.kind) {
                cargo.cargoId = cargo.containerDetails.kind;
            }
        });

        const nonEmptyLDLoad = Object.values(cargoRequest.ldRates.loading).filter(l => l);
        const nonEmptyLDDisch = Object.values(cargoRequest.ldRates.discharging).filter(l => l);

        if (!nonEmptyLDLoad.length) {
            cargoRequest.ldRates.loading = {
                type: '',
            };
        } else {
            cargoRequest.ldRates.loading = _.pickBy(cargoRequest.ldRates.loading, i => i);
        }

        if (!nonEmptyLDDisch.length) {
            cargoRequest.ldRates.discharging = {
                type: '',
            };
        } else {
            cargoRequest.ldRates.discharging = _.pickBy(cargoRequest.ldRates.discharging, i => i);
        }

        [
            'incoterms',
        ].forEach((field) => {
            if (!Object.values(cargoRequest[field]).filter(i => i).length) {
                cargoRequest[field] = undefined;
            }
        });

        fixVesselRequirementsData(cargoRequest.vesselRequirements);

        if (!error) {
            const req = {
                ...cargoRequest,
                mailId: this.props.letter._id,
                eh: this.props.letter.eh,
                clientCargo: this.state.clientCargo,
            };

            if (opts) {
                req.mailId = opts._id;
                req.eh = opts.context.kind;
                req.requestKind = opts.context.kind;
                req.clientCargo = opts.owner.email;
                req.user = opts.owner.email;
                req.realUserEmail = opts.realUserEmail;
            }

            if (shouldReturnPrepared) {
                return req;
            }

            this.props.postRequestCargo(req);
        }   
    }

    handleFillRequest(data) {
        this.setState({
            packingListSelection: data,
        });
    }

    updatePostGazetters(textLetter) {
        this.setState({
            textLetter,
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
            updated: true,
        }, async () => {
            await this.props.postGazetters(
                textLetter,
                {
                    emailId: this.props.letter._id,
                    subject: this.props.letter.subject,
                    date: moment(this.props.letter.date).format('DD-MM-YYYY'),
                },
            );
        });
    }

    componentWillUnmount() {
        this.props.removeGazetters();
        this.props.removeAnnotations();
        this.props.removeLetter();
    }

    handleClientChange(e, i, value) {
        this.setState({ clientCargo: value });
    }

    toggleAttachmentsDialog = () => {
        this.setState({
            openedAttachmentsDialog: !this.state.openedAttachmentsDialog,
        });
    }

    onUserUpdate = (newUser) => {
        this.props.updateCargoOrderUser(newUser);
    }

    toggleFailedToSentOpen = () => {
        this.setState({
            failedToSentOpen: !this.state.failedToSentOpen,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!_.isEqual(
            JSON.stringify(nextProps.cargoOrders), 
            JSON.stringify(this.state.cargoOrdersDuplicates),
        )) {
            this.setState({ isFormChanged: true });
        } else {
            this.setState({ isFormChanged: false });
        }
    }

    /**
     * @param {import('../../../Letters/common/FailedToSent').FailedTwin} failedTwinLetterData
     */
    async sendRequestCargoFromSent(failedTwinLetterData) {
        const cargoOrders = _.cloneDeep(this.props.cargoOrders);

        let hasErrors = false;

        cargoOrders.forEach((cargoOrder, cIndex) => {
            // like that because user error is seperate from main cargo object
            cargoOrder.validateErrors = _.omitBy(cargoOrder.validateErrors, (i) => {
                i.field === 'user';
            });

            if (cargoOrder.validateErrors.length) {
                cargoOrder.validateErrors.forEach((error) => {
                    this.props.addNotification({
                        title: 'Error',
                        message: `Error in request #${cIndex + 1}. Field ${error.field} --- ${error.message || error.messages[0]}`,
                        level: 'error',
                        _id: Math.random(),
                        autoDismiss: 100,
                    });
                });

                hasErrors = true;
            }
        });

        if (hasErrors) return;

        if (!cargoOrders.length) return;

        const cargoRequests = [];
        const results = [];

        this.createTerms(cargoOrders);

        cargoOrders.forEach((cargoOrder, keyCargoOrder) => {
            this.createCargoRequest(cargoOrder, keyCargoOrder, cargoRequests);
        });

        for (let cargoRequestIndex = 0; cargoRequestIndex < cargoRequests.length; cargoRequestIndex++) {
            const cargoRequest = cargoRequests[cargoRequestIndex];

            if (failedTwinLetterData.context.kind === 'broker') {
                cargoRequest.realUserEmail = failedTwinLetterData.realUserEmail;
                cargoRequest.user = failedTwinLetterData.context.mailGateEmail;
                cargoRequest.mailId = failedTwinLetterData._id;
            }

            const req = this._prepareAndOrSendSingleRequest(cargoRequest, cargoRequestIndex, true, failedTwinLetterData);

            const response = await api.postRequestCargo(req);

            if (response.status === 200) {
                results.push({
                    ...response.data,
                    status: 'success',
                });
                await api.sendRefNumber(failedTwinLetterData._id, {
                    refNo: response.data.refNo,
                    requestId: response.data.id || response.data._id,
                });
            } else {
                results.push({
                    status: 'error',
                    message: _.get(response, 'errors[0].message') ||
                         _.get(response, 'errors[0].messages[0]'),
                });
            }

            await helpers.sleep(1000);
        }

        return results;
    }

    render() {
        const {
            annotationsServer, clarifiedServer, textLetter, updated, clientCargo, openedAttachmentsDialog,
            isSimpleForm, sendStatusPending, failedToSentOpen,
        } = this.state;
        const {
            letter, routeParams, router, cargoOrders, objUser, user, location, 
        } = this.props;

        let modifiedTextLetter;
        let initialTextLetter;

        if (location.state) {
            modifiedTextLetter = location.state.modifiedTextLetter;
            initialTextLetter = location.state.initialTextLetter;
        }

        const hasTcOrder = letter && letter.clarified && letter.clarified.find(c => c.typeCategory && c.typeCategory.includes('tc'));

        return (
            <div id='single-letter-cargo' className='single-letter'>
                <div className='content' style={{ width: '60vw' }}>
                    <div className='management'>
                        <div className='management-children'>
                            <RaisedButton
                                className='btn'
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                label='Gazetteer'
                                containerElement={<Link to={`/${routeParams.id}`} />}
                                primary
                            />

                            <ErrorBoundary>
                                <HtmlContent letter={letter} />
                            </ErrorBoundary>

                            <TextEditor 
                                textLetter={modifiedTextLetter || textLetter || letter.text}
                                originalText={initialTextLetter || letter.text}
                                removeGazetters={this.props.removeGazetters}
                                removeAnnotations={this.props.removeAnnotations}
                                getLetterData={this.getLetterData}
                                updatePostGazetters={this.updatePostGazetters}
                            />

                            <Attachments 
                                openedAttachmentsDialog={openedAttachmentsDialog}
                                toggleAttachmentsDialog={this.toggleAttachmentsDialog}
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '10px' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                className='btn'
                                attachments={letter.attachments}
                            />
                            <SelectField
                                floatingLabelText='Annotations server'
                                className='btn'
                                style={{ width: '155px' }}
                                value={annotationsServer}
                                onChange={this.changeAnnotationsServer}
                                selected
                            >
                                <MenuItem value='mailparse.net' primaryText='mailparse.net' />
                                <MenuItem value='s4.anotatr.com' primaryText='s4.anotatr.com' />
                                <MenuItem value='nata.im' primaryText='nata.im' />
                                <MenuItem value='polza' primaryText='polza' />
                                <MenuItem value='localhost' primaryText='localhost' />
                            </SelectField>

                            <SelectField
                                floatingLabelText='Clarified server'
                                className='btn'
                                style={{ width: '110px' }}
                                value={clarifiedServer}
                                onChange={this.changeClarifiedServer}
                                selected
                                autoWidth
                            >
                                <MenuItem value='standart' primaryText='api' />
                                <MenuItem value='localhost:7775' primaryText='localhost' />
                                <MenuItem value='s4.anotatr.com:7777' primaryText='s4.anotatr.com' />
                            </SelectField>
                            <Checkbox 
                                style={{ 
                                    display: 'inline-block',
                                    width: 'auto',
                                    verticalAlign: 'middle', 
                                    margin: '30px 10px 0 0', 
                                    fontSize: '14px',
                                }}
                                iconStyle={{ marginRight: '7px' }}
                                label="simple"
                                checked={isSimpleForm}
                                onCheck={() => { this.setState({ isSimpleForm: !isSimpleForm }); }}
                            />
                            <br />
                            {/* <Trainings letter={this.props.letter} /> */}
                            <ToSpamButton
                                letterId={letter._id}
                                onSuccess={() => {
                                    this.getLetterData();
                                }}
                                disabled={letter.type === 'spam'}
                            />
                            <FailedToSent
                                open={failedToSentOpen}
                                failedTwinsList={letter.failedTwinsByTextHash || []}
                                handleToggleDialog={this.toggleFailedToSentOpen}
                                disabled={this.state.isFormChanged}
                                sendRequest={this.sendRequestCargoFromSent}
                            />
                        </div>

                        <div style={{ width: '150px' }} className='subject'>SUBJECT: { letter.subject } </div>
                        <div className='subject' style={{ width: '70px' }}>refNo: { letter.refNo } </div>
                    </div>

                    {
                        updated ?
                            (
                                <ErrorBoundary>
                                    <AnnotationsEditor letterText={textLetter || letter.text} />
                                </ErrorBoundary>
                            )
                            :
                            (
                                <ErrorBoundary>
                                    <AnnotationsEditor letterText={modifiedTextLetter || letter.text} />
                                </ErrorBoundary>
                            )
                    }

                    <ErrorBoundary>
                        <AnnotationsList />
                    </ErrorBoundary>
                </div>
                <div className='sidebar' style={{ width: '40vw' }}>
                    <h1>Cargo requests {cargoOrders.length}<span style={{ color: 'red' }}>{ hasTcOrder && ' Has TC requests' }</span></h1>

                    <ErrorBoundary>
                        {
                            cargoOrders.map((cargoOrder, i) => (<OrderTable
                                captureSaveHandler={(fn) => {
                                    this.saveHandlers[i] = fn;
                                }}
                                numberOrderTable={i}
                                key={i}
                            />))
                        }
                    </ErrorBoundary>

                    <ErrorBoundary>
                        <UserSelector 
                            handleClientChange={this.handleClientChange}
                            client={clientCargo}
                            user={user}
                            letter={letter}
                            errorUser={cargoOrders[0] && cargoOrders[0].validateErrors.find(v => v.field === 'user')}
                            onUserUpdate={this.onUserUpdate}
                        />
                    </ErrorBoundary>

                    <ul className='controller-orders' style={{ width: '40vw' }}>
                        <li>
                            <FlatButton style={styles.btnNewOrders} onClick={this.addOrderTable} label='Add' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnNewOrders} onClick={this.removeOrderTable} label='Remove' />
                        </li>
                        <li>
                            <FlatButton style={styles.btnNewOrders} onClick={this.clearOrderTable} label='Clear' />
                        </li>
                        <li>
                            <FlatButton 
                                style={styles.btnNewOrders} 
                                onClick={_.debounce(this.sendRequestCargo, 500)} 
                                label='Send' 
                                disabled={sendStatusPending} 
                            />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect(
    ({
        user: objUser, cargoOrders: { user, items: cargoOrders }, user: { isLogged }, letter, annotations: { items: annotations }, 
    }) => ({
        objUser,
        user,
        cargoOrders,
        isLogged,
        letter,
        annotations,
    }),
    dispatch => bindActionCreators({
        updateCargoOrderUser,
        updateCargoOrder,
        postAnnotations,
        postGazetters,
        getCargoTypes,
        getTermEntities,
        addCargoOrder,
        postRequestCargo,
        getContracts,
        removeLastCargoOrder,
        getCargoAssigners,
        removeGazetters,
        removeAnnotations,
        removeLetter,
        addNotification,
        getCargoesByTypeName,
    }, dispatch),
)(LetterCargo);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/LetterCargo.jsx